module.exports = __webpack_public_path__ + "static/V R Mehta-e2a12fd89932fdc9a304a2583e93140f.jpg";